import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
`;
export const Label = styled.div `
  overflow: hidden;
  color: var(--text-primary);
  text-overflow: ellipsis;
  /* body/md/regular */
  font-family: var(--font-family-body);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);
`;
export const Sublabel = styled.div `
  overflow: hidden;
  color: var(--text-secondary);
  text-overflow: ellipsis;
  /* body/sm/regular */
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
`;
